import React from 'react';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import { twMerge } from 'tailwind-merge';
import { ReactComponent as Attach } from 'assets/icons/attach.svg';

interface CustomProps {
  id: string;
  className?: string;
  isLoading?: boolean;
}

interface IDropzone extends DropzoneOptions, CustomProps {}

const FormAttachButton: React.FC<IDropzone> = ({
  onDrop,
  accept,
  className,
  id,
}) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept,
    multiple: false,
  });

  return (
    <div
      id={id}
      className={twMerge('cursor-pointer', className)}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <Attach className="w-5 h-5 min-w-[1.25rem]" />
    </div>
  );
};

export default FormAttachButton;
